const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";


const ImgURL = process.env.REACT_APP_ImgURL || `${API_URL}/public/files`;
const FileURL = process.env.REACT_APP_ImgURL || `${API_URL}/assets/files`;



export {
    API_URL,
    ImgURL,
    FileURL
}